import { frontendURL } from 'dashboard/helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/synapse'),
    name: 'synapse',
    meta: { permissions: ['administrator'], featureModule: 'synapse' },
    component: () => import('./SynapseView.vue'),
  },
];
